import styles from './SecondaryFooter.module.scss';
import { FooterLogo } from '../FooterLogo/FooterLogo';
import { FormattedMessage } from 'react-intl';
import { useFooterHandlers } from '../../hooks/useFooter';
import { FooterLink } from '../FooterLink/FooterLink';
import { getSecondaryFooterLinks } from '../../data/footerData';
import { BulletSeparator } from '../../../_shared/BulletSeparator';

interface SecondaryFooterProps {
  domainUrl: string;
}

export const SecondaryFooter: React.FC<SecondaryFooterProps> = ({ domainUrl }) => {
  const { manageCookiePreferences, doNotSellPersonalInfo, privacy } = getSecondaryFooterLinks(domainUrl);
  const { handleCookiePreferences, handleDoNotSell } = useFooterHandlers();

  return (
    <div className={styles.secondaryFooter}>
      <FooterLink link={manageCookiePreferences} onClick={handleCookiePreferences} />
      <BulletSeparator />
      <FooterLink link={doNotSellPersonalInfo} onClick={handleDoNotSell} />
      <BulletSeparator />
      <FooterLink link={privacy} />
      <a href={`${domainUrl}/r/ereg`} className={styles.footerLogo} aria-label="Eventbrite homepage">
        <FooterLogo />
        <span className={styles.footerHiddenAccessible}>
          <FormattedMessage id="Eventbrite + Ticketfly" defaultMessage="Eventbrite + Ticketfly" />
        </span>
      </a>
      <p className={styles.footerCopyright}>© {new Date().getFullYear()} Eventbrite</p>
    </div>
  );
};
